<template>
    <div class="modern-container">
        <!-- Header Card -->
        <div class="header-section">
            <div class="header-content">
                <div class="title-section">
                    <h1 class="main-title">
                        <v-icon class="title-icon">mdi-account-group</v-icon>
                        Armar Muñeco
                    </h1>
                    <p class="subtitle">Gestión de transferencia de materia</p>
                </div>
                <div class="switch-section">
                    <div class="switch-container mr-3">
                        <span class="switch-label">Ocultar datos inconsistentes</span>
                        <s-switch 
                            v-model="hideInconsistentData" 
                            color="error"
                        />
                    </div>
                    <div class="switch-container">
                        <span class="switch-label">Recordar filtros</span>
                        <s-switch 
                            v-model="recordateFilters" 
                            :true-value="1" 
                            :false-value="0"
                            color="primary"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Main Content -->
        <v-row class="main-content">
            <!-- Left Panel - Materia Prima -->
            <v-col cols="12" lg="7" class="pr-lg-3">
                <v-card class="material-card" elevation="3">
                    <!-- Stats Header -->
                    <v-card-title class="stats-header primary white--text">
                        <div class="d-flex align-center w-100">
                            <v-icon class="mr-3" large>mdi-factory</v-icon>
                            <div class="flex-grow-1">
                                <h3 class="headline font-weight-bold">Materia Prima en Proceso</h3>
                                <div class="stats-info mt-2">
                                    <v-chip class="mr-3" color="white" text-color="primary" label>
                                        <v-icon small class="mr-1">mdi-weight-kilogram</v-icon>
                                        Enviados: {{ SuLlpWeightOriginalNet | numberDefaultKg }}
                                    </v-chip>
                                    <v-chip color="white" text-color="primary" label>
                                        <v-icon small class="mr-1">mdi-package-variant</v-icon>
                                        Por C.: {{ SuCantPorC | numberDefaultKg }}
                                    </v-chip>
                                </div>
                            </div>
                        </div>
                    </v-card-title>

                    <v-card-text class="pa-4">
                        <!-- Filters Row -->
                        <v-row class="pb-4">
                            <v-col cols="12" md="3">
                                <s-select-definition
                                    :def="1173"
                                    v-model="filterProcess.TypeCultive"
                                    label="Tipo de Cultivo"
                                    @input="changeCultive($event)"
                                />
                            </v-col>
                            <v-col cols="12" md="3">
                                <s-select
                                    label="Medio de Ingreso"
                                    full
                                    item-value="SplID"
                                    item-text="SplName"
                                    :items="samplingLocation"
                                    v-model="splID"
                                    @input="splIDFilter($event)"
                                />
                            </v-col>
                            <v-col cols="12" md="2">
                                <s-date 
                                    label="Fecha Inicio"
                                    v-model="filterProcess.DateBegin" 
                                    @input="splIDFilter(splID)" 
                                />
                            </v-col>
                            <v-col cols="12" md="2">
                                <s-date 
                                    label="Fecha Fin"
                                    v-model="filterProcess.DateEnd"  
                                    @input="splIDFilter(splID)" 
                                />
                            </v-col>
                            <v-col cols="12" md="2">
                                <s-select-definition 
                                    label="Turno"
                                    v-model="filterProcess.TypeTurn"  
                                    :def="1278"
                                    @change="splIDFilter(splID)" 
                                    clearable
                                />
                            </v-col>
                        </v-row>

                        <!-- Data Table -->
                        <v-card class="table-card" elevation="2">
                            <v-data-table
                                :headers="headerPalletGoing"
                                :items="filteredPalletsGoing"
                                :item-class="getItemClass"
                                dense
                                class="modern-table"
                                :items-per-page="10"
                                height="320px"
                            > 
                                <!-- eslint-disable-next-line vue/valid-v-slot -->
                                <template v-slot:item.StockJaba="{ item }">
                                    <span>{{ item.effectiveStock !== undefined ? item.effectiveStock : item.StockJaba }}</span>
                                </template>
                                <!-- eslint-disable-next-line vue/valid-v-slot -->
                                <template v-slot:item.DldQuantity="{ item }"> 
                                    <v-card class="quantity-input pa-2" outlined style="width: 100px; margin: auto;">
                                        <s-text 
                                            v-model.number="item.DldQuantity"
                                            number
                                            :min="0"
                                            :max="item.effectiveStock !== undefined ? item.effectiveStock : item.StockJaba"
                                            dense
                                            hide-details
                                        />
                                    </v-card>
                                </template>
                                <!-- eslint-disable-next-line vue/valid-v-slot -->
                                <template v-slot:item.Armed="{ item }">
                                    <v-btn
                                        color="success"
                                        :disabled="false"
                                        fab
                                        small
                                        @click="armed(item)"
                                        class="armed-btn"
                                    >
                                        <v-icon>mdi-send</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Right Panel - Muñecos Transferidos -->
            <v-col cols="12" lg="5" class="pl-lg-3">
                <v-card class="transfer-card" elevation="3">
                    <!-- Transfer Header -->
                    <v-card-title class="transfer-header warning white--text" style="position: relative;">
                        <div class="d-flex align-center w-100">
                            <v-icon class="mr-3" large>mdi-dolly</v-icon>
                            <div class="flex-grow-1">
                                <h3 class="headline font-weight-bold">Muñecos Transferidos</h3>
                                <v-chip class="mt-2" color="white" text-color="warning" label>
                                    <v-icon small class="mr-1">mdi-weight-kilogram</v-icon>
                                    {{ SuToAverageWeightJabaN | numberDefaultKg }}
                                </v-chip>
                            </div>
                        </div>
                        <img v-if="backgroundMuneco" src="/static/SUPERMAN.png" alt="" style="z-index: 1; ;width: 100px; height: 90px; object-fit: cover; position: absolute; bottom: 0; right: 0; object-position: top; opacity: 0.15;">
                    </v-card-title>

                    <v-card-text class="pa-4">
                        <!-- Transfer Table -->
                        <v-card class="table-card mb-4" elevation="1">
                            <v-data-table
                                :headers="headerDollArmed"
                                :items="detailsArmed"
                                v-model="armdedSelected"
                                dense
                                item-key="uniqueId"
                                show-select
                                class="modern-table"
                                :items-per-page="5"
                            >
                                <!-- eslint-disable-next-line vue/valid-v-slot -->
                                <template v-slot:item.DlpCodBase="{ item }">
                                    <s-text
                                        v-model="item.DlpCodBase"
                                        number
                                        :min="0"
                                        dense
                                        hide-details
                                    />
                                </template>
                                <!-- eslint-disable-next-line vue/valid-v-slot -->
                                <template v-slot:item.remove="{ item }">
                                    <v-btn
                                        @click="clickDelete(item)"
                                        small
                                        fab
                                        color="error"
                                        class="remove-btn"
                                    >
                                        <v-icon small>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
 
                        <!-- Control Panel -->
                        <v-card class="control-panel" elevation="2">
                            <v-card-title class="control-header info white--text">
                                <v-icon class="mr-2">mdi-cog</v-icon>
                                Panel de Control
                            </v-card-title>
                            <v-card-text class="pa-4">

                                <!-- Tipo de Envío -->
                                <v-card class="mb-4" outlined>
                                    <v-card-text class="pa-3">
                                        <s-select-definition
                                            :def="1425"
                                            label="Tipo de Envío"
                                            radio
                                            row
                                            v-model.number="typeSend"
                                        />
                                    </v-card-text>
                                </v-card>

                                <!-- Send Button -->
                                <v-btn 
                                    @click="openModal()"
                                    color="primary"
                                    block
                                    large
                                    class="send-btn"
                                    elevation="2"
                                >
                                    <v-icon class="mr-2">mdi-send</v-icon>
                                    Enviar Muñeco
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Location Component -->
        <v-row class="mt-6">
            <v-col cols="12">
                <v-card class="location-card" elevation="2">
                    <v-card-title class="location-header success white--text">
                        <v-icon class="mr-2" large>mdi-map-marker</v-icon>
                        Ubicación de Muñecos
                    </v-card-title>
                    <v-card-text class="pa-4">
                        <LocationDoll :key="componentKey" :filter="filterProcess" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Modal Dialog -->
        <v-dialog
            v-model="dialogSend"
            v-if="dialogSend"
            persistent
            transition="dialog-bottom-transition"
            fullscreen
        >
            <v-card class="dialog-card">
                <v-app-bar dark color="primary" elevation="0">
                    <v-toolbar-title class="headline font-weight-bold">
                        <v-icon class="mr-2">mdi-send</v-icon>
                        Procesar Envío
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="ClosedialogSend()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>
                
                <v-container class="pa-6">
                    <v-row v-if="typeSend == 1">
                        <v-col>
                            <v-card elevation="2">
                                <v-card-title class="primary white--text">
                                    <v-icon class="mr-2">mdi-map-marker</v-icon>
                                    Seleccionar Ubicación
                                </v-card-title>
                                <v-card-text class="pa-4">
                                    <location-doll 
                                        @emitLocation="emitLocation($event)"
                                        armed
                                        notFilter
                                        :key="componentKey" :filter="filterProcess"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-if="typeSend == 2">
                        <v-col>
                            <v-card elevation="2">
                                <v-card-title class="primary white--text">
                                    <v-icon class="mr-2">mdi-table</v-icon>
                                    Seleccionar Mesa de Trabajo
                                </v-card-title>
                                <v-card-text class="pa-4">
                                    <tables-line 
                                        :filter="filterProcess"
                                        :detailsArmed="armdedSelected[0]"
                                        @emitTable="emitTable($event)"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- dialogSplitDoll Modal -->
        <v-dialog v-model="dialogSplitDoll" max-width="450px" persistent>
            <v-card class="rounded-lg">
                <v-card-title class="headline warning white--text font-weight-bold">
                    <v-icon class="mr-2" dark>mdi-format-list-bulleted-type</v-icon>
                    División de Jabas
                </v-card-title>
                <v-card-text class="pa-4">
                    <div class="subtitle-1 mb-4">
                        El pallet contiene <b>{{ splitItem.DldQuantity }}</b> jabas para procesar. Seleccione el tamaño de cada muñeco:
                    </div>
                    <v-radio-group v-model="splitSize" row mandatory class="mb-4">
                        <v-radio label="3 jabas" :value="3"></v-radio>
                        <v-radio label="4 jabas" :value="4"></v-radio>
                        <v-radio label="Acumulado (Todas las jabas)" :value="-1"></v-radio>
                        <v-radio label="Personalizado" :value="0"></v-radio>
                    </v-radio-group>
                    <v-text-field
                        v-if="splitSize === 0"
                        label="Cantidad de jabas por muñeco"
                        type="number"
                        v-model.number="customSplitSize"
                        :min="1"
                        :max="maxJabas"
                        outlined
                        dense
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="pa-4 pt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="dialogSplitDoll = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="confirmSplitDoll">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- AlertSunshine loader -->
        <AlertSunshine :dialog="processing" :text="processingText" :totalItems="totalItems" :countItems="countItems" />
    </div>
</template>

<script>
    import _armedDoolService from '@/services/FrozenProduction/ArmedDollService'
    import _sParameter from "@/services/General/ParameterService.js";
    import _sSamplingLocationService from '@/services/FrozenProduction/SamplingLocationService.js';
    import _sTurnService from '@/services/FreshProduction/PrfTurnService';

    import LocationDoll from './LocationDoll.vue'
    import TablesLine from '@/components/FrozenProduction/Aconditionado/TablesLine.vue'
    import AlertSunshine from '@/components/Utils/AlertSunshine.vue'

    export default {
        components: {
            LocationDoll,
            TablesLine,
            AlertSunshine,
        },
        data() {
            return  {
                hideInconsistentData: true,
                palletsGoing : [],
                backgroundMuneco: false,
                activeTurn: null,
                headerPalletGoing: [
                    { text: "#", value: "LlpID" },
                    { text: "N° Pallet", value: "LlpCorrelative" },
                    { text: "Destino", value: "TypeDestination" },
                    { text: "Variedad", value: "VrtDescription" },
                    { text: "Peso Promedio Kg", value: "AverageKgJaba" },
                    { text: "Calibre", value: "TypeFrozenCategoryName" },
                    { text: "Lote M.", value: "PrfYuliano" },
                    // { text: "Jabas recep.", value: "LpsQuantityJaba" },  
                    { text: "Stock", value: "StockJaba" }, 
                    { text: "N° Jabas", value: "DldQuantity" },
                    { text: "Armar", value: "Armed" },
                ],
                selectedItem: [],
                headerDollArmed: [
                    { text: "#", value: "LlpID" },
                    { text: "N° Pallet", value: "LlpCorrelative" },
                    { text: "Lote de materia prima", value: "PrfYuliano" },
                    { text: "Cantidad de Jabas", value: "DldQuantity" },
                    { text: "Cód. Jaba Base", value: "DlpCodBase" },
                    { text: "Eliminar", value: "remove" },
                ],
                armdedSelected: [],
                detailsArmed: [],
                dialogSplitDoll: false,
                splitItem: {},
                splitSize: -1,
                customSplitSize: 4,
                processing: false,
                processingText: "Cargando...",
                totalItems: 0,
                countItems: 0,
                headerDoll: [
                    { text: "#", value: "DlpID" },
                    { text: "N° Lote", value: "RcfID" },
                    { text: "Correlativo", value: "DlpCorrelative" },
                    { text: "Lote de materia prima", value: "DlpJuliano" },
                    { text: "Cantidad de Jabas", value: "DlpQuantity" },
                    { text: "Variedad", value: "VrtName" },
                    { text: "Lugar", value: "TypeSendName" },
                    { text: "Ubicacion", value: "DlpPosition" },
                    { text: "Tipo Cultivo", value: "TypeCropName" },
                ],
                dollsArmed: [],
                selectedDoll: [],
                maxJabas: 0,
                filter: {},
                filterProcess: {
                    TypeCultive: 0,
                    TrnID: null,
                    DateBegin: "",
                    DateEnd: "",
                    TypeTurn: null,
                },
                samplingLocation: [],
                splID:0,
                dialogSend: false,
                typeSend: 0, 
                ClpID: 0,//linea en proceso
                componentKey: 0,
                DlpCodBase: 0,
              //  SumWeightNetProccess: 0,
               // QuantityJaba: 0,
                WeightJaba: 0,
               // JabasSend: 0,
               // WeightSendLine: 0,
                SuLlpWeightOriginalNet:0,
                SuToAverageWeightJabaN:0,
                SuCantPorC:0,
                recordateFilters:0,
            }
        },
// selectedItemd: {},
        watch: {
            "filterProcess.TypeCultive"(){
                this.samplingLocation = [];
                this.SuLlpWeightOriginalNet=0;
                this.SuToAverageWeightJabaN=0;
                this.SuCantPorC=0;
               // this.SumWeightNetProccess = 0;
               // this.QuantityJaba = 0;
                this.WeightJaba = 0;
                //this.JabasSend = 0;
               // this.WeightSendLine = 0;
                _sSamplingLocationService
                .list( this.filterProcess , this.$fun.getUserID())
                .then(resp => {
                    if(resp.status == 200)
                    {
                        this.samplingLocation = resp.data;
                    }
                })
            },
            recordateFilters(val) {
                localStorage.setItem("recordateFiltersDoll", val);
                let filters = {
                    TypeCultive: this.filterProcess.TypeCultive,
                    splID: this.splID,
                    DateBegin: this.filterProcess.DateBegin,
                    DateEnd: this.filterProcess.DateEnd,
                    TypeTurn: this.filterProcess.TypeTurn
                };
                if (val == 1) { 
                    localStorage.setItem("filterDoll", JSON.stringify(filters));
                } else {
                    localStorage.removeItem("filterDoll");
                }
            },
            filterProcess: {
                handler(val) {
                    if (!val) return;

                    const data = {
                        TypeCultive: val.TypeCultive,
                        splID: this.splID,
                        DateBegin: val.DateBegin,
                        DateEnd: val.DateEnd,
                        TypeTurn: val.TypeTurn
                    };
                    if(this.recordateFilters == 1){
                        localStorage.setItem("filterDoll", JSON.stringify(data));
                    }
                },
                deep: true
            },
            splID(val){
                const data = {
                    TypeCultive: this.filterProcess.TypeCultive,
                    splID: this.splID,
                    DateBegin: this.filterProcess.DateBegin,
                    DateEnd: this.filterProcess.DateEnd,
                    TypeTurn: this.filterProcess.TypeTurn
                };
                if(this.recordateFilters == 1){
                    localStorage.setItem("filterDoll", JSON.stringify(data));
                }
            },
            hideInconsistentData(val) {
                localStorage.setItem("hideInconsistentDataDoll", JSON.stringify(val));
            },
        },
        methods: {
            getDataFilters() {
                const recordateFilters = localStorage.getItem('recordateFiltersDoll');
                this.recordateFilters = recordateFilters == '1' ? 1 : 0;
                if (this.recordateFilters == 1 && localStorage.filterDoll) {                   
                    try {
                        const filterDoll = JSON.parse(localStorage.filterDoll);
                        if (filterDoll) {
                            if (filterDoll.TypeCultive !== undefined) this.filterProcess.TypeCultive = filterDoll.TypeCultive;
                            if (filterDoll.DateBegin) this.filterProcess.DateBegin = filterDoll.DateBegin;
                            if (filterDoll.DateEnd) this.filterProcess.DateEnd = filterDoll.DateEnd;
                            if (filterDoll.TypeTurn !== undefined && filterDoll.TypeTurn !== null) this.filterProcess.TypeTurn = filterDoll.TypeTurn;
                            if (filterDoll.splID !== undefined) this.splID = filterDoll.splID;
                        }
                    } catch (e) {
                        console.error("Error reading saved filterDoll from localStorage", e);
                    }
                }
                const savedHideState = localStorage.getItem('hideInconsistentDataDoll');
                
                if (savedHideState !== null) {
                    this.hideInconsistentData = JSON.parse(savedHideState);
                } else {
                    this.hideInconsistentData = true;
                }
            }, 
            ClosedialogSend(){
                this.dialogSend = false;
                this.forceRender();
            },
            changeCultive(cultive){
                this.palletsGoing = [];
            },
            forceRender() {                
                this.componentKey += 1;
            },
            clickDelete( item ){
                this.detailsArmed =
                    this.detailsArmed.filter(
                    (x) => x.uniqueId !== item.uniqueId
                    );
                this.armdedSelected = this.detailsArmed;
            },
            emitLocation(obj){
                
                
                let column = obj.item.DedDescription
                let rows = obj.item2.DedDescription

                this.save( 1, rows, column, null );
                
            },
            emitTable( table ){
               
                this.ClpID = table.ClpID;
                this.save( 2, null, null, table );
            },
            openModal(){
                
                if(this.detailsArmed.length == 0){
                    this.$fun.alert("Agregar jabas para crear muñeco", "warning")
                    return;
                }
                if(this.armdedSelected.length == 0){
                    this.$fun.alert("Debe seleccionar al menos una fila en Muñeco Trasnferidos para crear muñeco","warning");
                    return;
                }
                // if(!this.DlpCodBase){
                //     this.$fun.alert("Agregar codigo Jaba", "warning")
                //     return;
                // }
                if(!this.typeSend){
                    this.$fun.alert("Seleccione tipo destino", "warning")
                    return;
                }                

                this.dialogSend = true;
            },
            splIDFilter(splID){
                 
                 this.palletsGoing = [];

                 this.splID = splID;
                console.log("splID", this.splID);
                this.loadPalletGoing( this.splID );
            },
            loadPalletGoing(splID){
                if (!splID) return;
                this.processingText = "Cargando materia prima en proceso...";
                this.processing = true;
                const filter = {
                    splID: splID,
                    DateBegin: this.filterProcess?.DateBegin || this.$fun.dateCurrent(),
                    DateEnd: this.filterProcess?.DateEnd || this.$fun.dateCurrent(),
                    TypeTurn: this.filterProcess?.TypeTurn || (this.activeTurn ? this.activeTurn.TypeTurn : null),
                    TrnID: this.filterProcess?.TrnID || (this.activeTurn ? this.activeTurn.TrnID : null)
                };
                _armedDoolService.palletGoing(filter, this.$fun.getUserID())
                    .then((r) => {

                        if (r.status == 200) {
                            this.SuLlpWeightOriginalNet=0;
                            this.SuToAverageWeightJabaN=0;
                            this.SuCantPorC=0;
                            console.log("palletsGoing", r.data);
                            this.palletsGoing = r.data;
                            this.WeightJaba = 0;
                            this.palletsGoing.forEach( (r) => 
                            {
                                r.DldQuantity = r.StockJaba;
                                this.SuLlpWeightOriginalNet += r.LlpWeightOriginalNet;
                                this.SuToAverageWeightJabaN += r.ToAverageWeightJabaN;
                                this.SuCantPorC += r.CantPorC;
                            });
                            this.getDlpCodBase();
                        }
                    })
                    .catch((err) => {
                        console.error("Error al cargar materia prima:", err);
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            },
            getDlpCodBase()
            {
                _armedDoolService.getDlpCodBase({ TypeCultive: this.filterProcess.TypeCultive }, this.$fun.getUserID())
                    .then((r) => {                        
                        this.DlpCodBase = r.data.DlpCodBase;
                    });
            },
            remove(item){

            },
            armed(item){
                if (this.isInconsistent(item)) {
                    this.$fun.alert("Este pallet contiene datos inconsistentes y no puede ser procesado", "error");
                    return;
                }

                const availableStock = item.effectiveStock !== undefined ? item.effectiveStock : item.StockJaba;

                if (item.DldQuantity == 0 || item.DldQuantity === null || item.DldQuantity === undefined) {
                    this.$fun.alert("La cantidad de jabas debe ser mayor a 0", "warning");
                    return;
                }

                if (item.DldQuantity > availableStock) {
                    this.$fun.alert("La cantidad de jabas para armar debe ser menor o igual al stock disponible", "warning");
                    return;
                }

                if (item.DldQuantity > this.maxJabas) {
                    this.splitItem = item;
                    this.splitSize = -1;
                    this.customSplitSize = 4;
                    this.dialogSplitDoll = true;
                } else {
                    const now = Date.now();
                    let currentBaseCode = parseInt(this.DlpCodBase) || null;
                    const newDoll = {
                        ...item,
                        uniqueId: `${now}_0`,
                        DlpCodBase: currentBaseCode
                    };
                    if (currentBaseCode !== null) {
                        currentBaseCode++;
                        this.DlpCodBase = currentBaseCode;
                    }
                    this.detailsArmed.push(newDoll);
                    this.armdedSelected = this.detailsArmed;
                }
            },
            confirmSplitDoll() {
                if (this.splitSize === -1) {
                    const now = Date.now();
                    let currentBaseCode = parseInt(this.DlpCodBase) || null;
                    const newDoll = {
                        ...this.splitItem,
                        uniqueId: `${now}_0`,
                        DldQuantity: this.splitItem.DldQuantity,
                        DlpCodBase: currentBaseCode
                    };
                    if (currentBaseCode !== null) {
                        currentBaseCode++;
                        this.DlpCodBase = currentBaseCode;
                    }
                    this.detailsArmed.push(newDoll);
                    this.armdedSelected = this.detailsArmed;
                    this.dialogSplitDoll = false;
                    return;
                }

                const size = this.splitSize === 0 ? this.customSplitSize : this.splitSize;
                if (!size || size <= 0) {
                    this.$fun.alert("El tamaño del muñeco debe ser mayor a 0", "warning");
                    return;
                }

                let total = this.splitItem.DldQuantity;
                const tempDetails = [];
                const now = Date.now();
                let index = 0;

                let currentBaseCode = parseInt(this.DlpCodBase) || null;

                while (total > 0) {
                    const currentSize = Math.min(total, size);
                    total -= currentSize;

                    const newDoll = {
                        ...this.splitItem,
                        uniqueId: `${now}_${index}`,
                        DldQuantity: currentSize,
                        DlpCodBase: currentBaseCode
                    };
                    tempDetails.push(newDoll);
                    if (currentBaseCode !== null) {
                        currentBaseCode++;
                    }
                    index++;
                }

                this.DlpCodBase = currentBaseCode;

                this.detailsArmed.push(...tempDetails);
                this.armdedSelected = this.detailsArmed;
                this.dialogSplitDoll = false;
            },
            async save(typeSend, row, col, table){
                if (typeSend == 2 && table?.difProcess == 1 && (table?.DescripcionIQF === null || table?.DescripcionIQF === "")) {
                    this.$fun.alert("Campo observacón es obligatorio", "warning");
                    return;
                }

                if (this.armdedSelected.length === 0) {
                    this.$fun.alert("Debe seleccionar al menos un muñeco", "warning");
                    return;
                }

                // Valida que cada fila seleccionada tenga un DlpCodBase válido
                const invalidCodBase = this.armdedSelected.filter(item => !item.DlpCodBase);
                if (invalidCodBase.length > 0) {
                    this.$fun.alert("Todos los muñecos seleccionados deben tener un Código de Jaba Base válido", "warning");
                    return;
                }

                const confirmResponse = await this.$fun.alert("¿Está seguro de guardar todos los muñecos seleccionados?", "question");
                if (!confirmResponse || !confirmResponse.value) {
                    return;
                }

                // Activar estado de carga para evitar clics duplicados
                this.processing = true;
                this.processingText = "Guardando muñecos secuencialmente...";
                this.totalItems = this.armdedSelected.length;
                this.countItems = 0;

                const savedIds = [];
                let hasErrors = false;

                try {
                    for (const selectedItem of this.armdedSelected) {
                        const doll = {
                            DlpQuantity: selectedItem.DldQuantity,
                            DlpJuliano: selectedItem.PrfYuliano,
                            FrzDollProccessDetails: [selectedItem],
                            TypeSend: typeSend,
                            VrtID: selectedItem.VrtID,
                            TypeCultive: selectedItem.TypeCultive,
                            TypeCrop: selectedItem.TypeCrop,
                            DlpRow: row,
                            DlpCol: col,
                            CttID: table?.CttID,
                            DescripcionIQF: table?.DescripcionIQF,
                            TypeSelectionFrozen: selectedItem.TypeSelectionFrozen,
                            TypeFrozenCategory: selectedItem.TypeFrozenCategory,
                            UsrCreateID: this.$fun.getUserID(),
                            ClpID: this.ClpID,
                            DlpCodBase: selectedItem.DlpCodBase,
                            AverageWeightJabaN: selectedItem.DldQuantity * (selectedItem.AverageKgJaba || this.WeightJaba || 0),
                            ToAverageWeightJabaN: selectedItem.DldQuantity * (selectedItem.AverageKgJaba || this.WeightJaba || 0),
                            TrnID: this.activeTurn ? this.activeTurn.TrnID : (selectedItem.TrnID || null),
                        };

                        const response = await _armedDoolService.save(doll, this.$fun.getUserID());
                        if (response && response.status === 200) {
                            savedIds.push(selectedItem.uniqueId);
                            this.countItems++;
                        } else {
                            hasErrors = true;
                            console.error("Error al guardar muñeco:", response);
                        }
                    }

                    if (savedIds.length > 0) {
                        const remainingItems = this.detailsArmed.filter(
                            item => !savedIds.includes(item.uniqueId)
                        );
                        this.detailsArmed = remainingItems;
                        this.armdedSelected = remainingItems;
                        this.loadList();
                        this.dialogSend = false;
                        this.loadPalletGoing(this.splID);
                        this.forceRender();
                    }

                    if (hasErrors) {
                        this.$fun.alert("Algunos muñecos no se pudieron guardar", "error");
                    } else {
                        this.$fun.alert("Guardados secuencialmente con éxito", "success");
                    }

                } catch (err) {
                    console.error("Error al guardar muñecos masivos:", err);
                    this.$fun.alert("Ocurrió un error al guardar los muñecos", "error");
                } finally {
                    this.processing = false;
                    this.totalItems = 0;
                    this.countItems = 0;
                }
            },
            loadList(){
                _armedDoolService.list(this.filter, this.$fun.getUserID())
                .then((r) => {
                    if (r.status == 200) {
                        this.dollsArmed = r.data;
                        
                    }
                });
            },
            isInconsistent(item) {
                const calibre = item.TypeFrozenCategoryName;
                const avgWeight = item.AverageKgJaba;
                const stock = item.StockJaba;

                const isCalibreInconsistent = !calibre || calibre.trim() === '' || calibre.trim().toLowerCase() === 'descarte';
                const isWeightInconsistent = avgWeight === null || avgWeight === undefined || avgWeight <= 0;
                const isStockInconsistent = stock === null || stock === undefined || stock < 1;

                return isCalibreInconsistent || isWeightInconsistent || isStockInconsistent;
            },
            async loadActiveTurn() {
                try {
                    const r = await _sTurnService.turnActive({ TypeArea: 4 }, this.$fun.getUserID());
                    if (r.status === 200 && r.data.length > 0) {
                        this.activeTurn = r.data[0];
                        if (this.filterProcess) {
                            this.$set(this.filterProcess, 'TrnID', this.activeTurn.TrnID);
                            if (!this.filterProcess.TypeTurn && this.activeTurn.TypeTurn) {
                                this.$set(this.filterProcess, 'TypeTurn', this.activeTurn.TypeTurn);
                            }
                        }
                        if (this.splID) {
                            this.loadPalletGoing(this.splID);
                        }
                    }
                } catch (e) {
                    console.error("Error loading active turn in ArmedDoll:", e);
                }
            },
            getItemClass(item) {
                if (this.isInconsistent(item)) {
                    return 'inconsistent-row';
                }
                return '';
            },
        },
        computed: {
            filteredPalletsGoing() {
                return this.palletsGoing
                    .map(item => {
                        const pendingJabas = (this.detailsArmed || [])
                            .filter(d => (d.LlpID && d.LlpID === item.LlpID) || (d.LpsID && d.LpsID === item.LpsID))
                            .reduce((sum, d) => sum + (Number(d.DldQuantity) || 0), 0);
                        const effectiveStock = Math.max(0, (item.StockJaba || 0) - pendingJabas);
                        const currentDld = (item.DldQuantity === undefined || item.DldQuantity === null || item.DldQuantity > effectiveStock)
                            ? effectiveStock
                            : item.DldQuantity;
                        return {
                            ...item,
                            effectiveStock,
                            DldQuantity: currentDld
                        };
                    })
                    .filter(item => {
                        if (item.effectiveStock <= 0) return false;
                        if (this.hideInconsistentData && this.isInconsistent(item)) return false;
                        return true;
                    });
            }
        },
        created(){
            // 1. Restaurar primero los filtros guardados en localStorage
            this.getDataFilters();

            // 2. Si no había fechas guardadas, asignar fecha actual por defecto
            if (this.filterProcess) {
                if (!this.filterProcess.DateBegin) {
                    this.$set(this.filterProcess, 'DateBegin', this.$fun.dateCurrent());
                }
                if (!this.filterProcess.DateEnd) {
                    this.$set(this.filterProcess, 'DateEnd', this.$fun.dateCurrent());
                }
            }

            // 3. Cargar turno activo y ejecutar consultas iniciales
            this.loadActiveTurn();

            _sParameter.search({ PrmName: "maxjabasmunecosacondicionado"}, this.$fun.getUserID()).then((r) => {
              this.maxJabas  = r.data.PrmValue ?? 0;
            });
            _sParameter.search({ PrmName: "backgroundMuneco"}, this.$fun.getUserID()).then((r) => {
              this.backgroundMuneco  = r.data.PrmValue ?? 0;
            });
        },
        mounted(){ 
        }
    }

</script>

<style scoped>
.header-section {
    margin-bottom: 20px;
}

.header-content {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 10px 30px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.main-title {
    font-size: 2.2rem;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 15px;
}

.title-icon {
    font-size: 2.5rem !important;
    color: #667eea;
}

.subtitle {
    color: #7f8c8d;
    font-size: 1.1rem;
    margin: 0;
}

.switch-section {
    display: flex;
    align-items: center;
}

.switch-container {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 5px 10px;
    background: rgba(102, 126, 234, 0.1);
    border-radius: 15px;
    border: 2px solid rgba(102, 126, 234, 0.2);
}

.switch-label {
    font-weight: 500;
    color: #2c3e50;
}

.stats-header {
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    border-radius: 0;
}

.transfer-header {
    background: linear-gradient(135deg, #ff9800 0%, #ffb74d 100%);
}

.location-header {
    background: linear-gradient(135deg, #4caf50 0%, #81c784 100%);
}

.stats-info .v-chip {
    margin-bottom: 5px;
    font-weight: 500;
}

.table-card {
    border-radius: 10px;
    overflow: hidden;
}

.modern-table {
    background: rgba(255, 255, 255, 0.9);
}

.modern-table .v-data-table-header {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.modern-table tbody tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

.quantity-input {
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.9);
}

.control-panel {
    border-radius: 10px;
    overflow: hidden;
}

.control-header {
    background: linear-gradient(135deg, #17a2b8 0%, #20c997 100%);
}

.send-btn {
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%) !important;
    border-radius: 25px;
    font-weight: bold;
    text-transform: none;
    transition: all 0.3s ease;
}
.inconsistent-row {
    background-color: #ffebee !important;
    opacity: 0.85;
}
.inconsistent-row:hover {
    background-color: #ffcdd2 !important;
}
</style>